import { render, staticRenderFns } from "./parametrosTemporales.vue?vue&type=template&id=78b0772f"
import script from "./parametrosTemporales.vue?vue&type=script&lang=js"
export * from "./parametrosTemporales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports